import { createSelector } from '@reduxjs/toolkit';

export const selectParams = (state) => state.upcomingDates.params;
export const selectData = (state) => state.upcomingDates.data;
export const selectError = (state) => state.upcomingDates.error;
export const selectFetchCounter = (state) => state.upcomingDates.fetchCounter;
export const selectLoading = (state) => state.upcomingDates.loading;

export const selectPartialData = createSelector([selectData, selectParams], (data, params) => {
  const { page, count } = params || {};
  const startIndex = (page - 1) * count;
  const endIndex = page * count;
  return data?.slice(startIndex, endIndex);
});

export const selectPageCount = createSelector([selectData, selectParams], (data, params) => {
  const { count } = params || {};
  return Math.ceil(data?.length / count);
});
